module.exports = __webpack_public_path__ + "static/img/balance-bg.fa5a5a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/balance-bg.png
// module id = DYC8
// module chunks = 0